import React from 'react';

import type { StateProp } from '@swf/core/types/Wizard';

import type { Node } from './Flow';

export interface ServerContext extends Partial<StateProp> {
  node?: Node;
}

interface Props {
  context: ServerContext;
}

export const Context = React.createContext<ServerContext>({});

const StarsWizardServer: React.FunctionComponent<Props> = ({ children, context }) => (
  <Context.Provider value={context}>{children}</Context.Provider>
);

export default StarsWizardServer;
